import { takeEvery, put, call, all, SagaReturnType } from 'redux-saga/effects';
import { patientAction } from '../../actions/constant';
import patientService from 'src/services/apiServices/patientServices';

const {
  GET_THERAPIST_SINGLE_DISCIPLINE_REQUEST,
  GET_THERAPIST_SINGLE_DISCIPLINE_FAILURE,
  GET_THERAPIST_SINGLE_DISCIPLINE_SUCCESS,
  GET_THERAPIST_SINGLE_DISCIPLINE_LOADING,
} = patientAction;

function* getSingleTherapistDiscipline(payload: any): SagaReturnType<any> {
  yield put({ type: GET_THERAPIST_SINGLE_DISCIPLINE_LOADING });
  try {
    const response = yield call(patientService.getTherapistDisciplinePatient, {
      discipline: payload?.payload?.discipline,
    });
    if (response?.status === 200)
      yield put({
        type: GET_THERAPIST_SINGLE_DISCIPLINE_SUCCESS,
        payload: response?.data,
      });
    else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: GET_THERAPIST_SINGLE_DISCIPLINE_FAILURE, payload: error });
  }
}

function* getSingleTherapistDisciplineSaga() {
  yield takeEvery(GET_THERAPIST_SINGLE_DISCIPLINE_REQUEST, getSingleTherapistDiscipline);
}

export default getSingleTherapistDisciplineSaga;
